var _defs, _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _polygon, _path4, _path5, _path6, _path7, _path8, _path9, _rect5, _rect6, _path10, _path11, _rect7, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProdlineStandard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 390 54.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0055a0}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Premablock_Logo_2013") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 349.3,
    y: 0.3,
    width: 15.7,
    height: 54.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 250.8,
    width: 15.3,
    height: 54.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 211.3,
    y: 0.5,
    width: 14.9,
    height: 54.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0.5,
    width: 19.4,
    height: 54.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.6,31.2c3.6,5.3,2.6,14.1-.1,19.5-3.4,6.6-11.7,6.4-18.8,6.3V24.7C50.3,24,58,25,61.6,31.2Z",
    transform: "translate(-19.4 -24.2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M390.8,58.4l.8,1.4c6,6.3,11.8,12.7,17.8,19.1H388.2V39.8h17.9Z",
    transform: "translate(-19.4 -24.2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M323.7,46.4c4.2,6.3,4.3,15.9,1.3,22.8-2.2,5.8-8.9,9.4-15.4,9.8l-.1-40A15.46,15.46,0,0,1,323.7,46.4Z",
    transform: "translate(-19.4 -24.2)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "345.4 33.38 328.8 15.68 345.4 15.68 345.4 33.38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M347.1,73.78c.2.6.6,1.2,1.3,1.2,6.8.6,13-3.8,16.2-9.2-.2,3,1.5,7.5-2.5,8.9-5.6,4-14.2,5.9-21,3a19.73,19.73,0,0,1-11.5-16.8c-.6-7.4,1.9-14.5,8-18.5,2.9-1.2,5.9-2.4,9.4-2.4Z",
    transform: "translate(-19.4 -24.2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M306.2,78.9c-5.9-.5-12-2.6-14.9-7.9-4.1-6.6-3.9-16.7-.1-23.3,2.8-5.5,8.6-8.6,15-8.4Z",
    transform: "translate(-19.4 -24.2)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.1,44.16c3.1,3.8,4,9,3.9,14.4H119.6V39.46C123.6,39.76,127.7,40.56,130.1,44.16Z",
    transform: "translate(-19.4 -24.2)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116,74.16c1.2,1.4,3.6.9,5.4.8,5.5-.9,9.3-5.4,12.2-9.3v5.9c-4.8,6.1-12.2,8.6-20,7-7.6-1.7-12.6-7.2-14.1-15-1.5-8.8,1.7-17,8.3-22a14.2,14.2,0,0,1,8.2-1.8Z",
    transform: "translate(-19.4 -24.2)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.1,41.3a8.78,8.78,0,0,1,2.2,5.9,7.37,7.37,0,0,1-2.6,5.4A8.19,8.19,0,0,1,88,53.8a8.38,8.38,0,0,1-4.7-6.1,7.2,7.2,0,0,1,3-7C88.9,38.6,93.7,39,96.1,41.3Z",
    transform: "translate(-19.4 -24.2)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264.2,46.2c3.7,6.9,4.1,17.3,1,24.5-2.4,5.7-8.8,8.4-15.3,8.1h-.4V40.1C255.3,39.9,261.3,41.6,264.2,46.2Z",
    transform: "translate(-19.4 -24.2)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 137,
    y: 15.9,
    width: 15,
    height: 38.9
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 117.9,
    y: 15.9,
    width: 15.3,
    height: 38.9
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.4,45.4c1.3,2.8,1.1,6.1,1.1,9.5V79H175V40.2C180.6,40,187.1,39.7,189.4,45.4Z",
    transform: "translate(-19.4 -24.2)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.6,47.4c.9,10.2.3,21.1.5,31.6H212.9l-.1-33a9,9,0,0,0-3-4.9C216.5,38.8,224.8,40.9,227.6,47.4Z",
    transform: "translate(-19.4 -24.2)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 47.3,
    y: 15.4,
    width: 15.4,
    height: 39.4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.9,46.1c.8,1.9.2,3.6-.3,5.4a8.13,8.13,0,0,1-7.2,4.3c-3.2-.3-6.3-2-7.1-5.3a8.12,8.12,0,0,1,2.4-8.1c2.2-2.1,5.7-2.1,8.3-1A8.65,8.65,0,0,1,210.9,46.1Z",
    transform: "translate(-19.4 -24.2)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.5,79c-5.9.2-12.5.3-15.3-4.9a12,12,0,0,1-.7-9.8c2.7-6,9.6-6.6,16-6.1Z",
    transform: "translate(-19.4 -24.2)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M401.35,35.37a6.44,6.44,0,0,1-11-4.58,6.45,6.45,0,0,1,12.89,0A6.26,6.26,0,0,1,401.35,35.37Zm-8.49-8.5a5.63,5.63,0,0,0,0,7.88,5.52,5.52,0,0,0,7.85,0,5.41,5.41,0,0,0,1.62-3.95,5.54,5.54,0,0,0-9.47-3.93Zm3.8.36a5.4,5.4,0,0,1,1.93.25,1.76,1.76,0,0,1,1.1,1.8,1.56,1.56,0,0,1-.69,1.4,2.59,2.59,0,0,1-1,.34,1.72,1.72,0,0,1,1.21.69,2,2,0,0,1,.39,1.1v.52a5,5,0,0,0,0,.53,1.15,1.15,0,0,0,.06.37l0,.08h-1.17v-.07a.19.19,0,0,1,0-.08l0-.22v-.56a1.71,1.71,0,0,0-.67-1.62,2.85,2.85,0,0,0-1.38-.23h-1v2.78h-1.25V27.23ZM398,28.35a3.2,3.2,0,0,0-1.51-.27h-1.07v2.57h1.13a3.3,3.3,0,0,0,1.19-.16,1.27,1.27,0,0,0,.26-2.14Z",
    transform: "translate(-19.4 -24.2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdlineStandard1);
export default __webpack_public_path__ + "static/media/prodline_standard1.8d019a80c05c029aad7166bd4890f53f.svg";
export { ForwardRef as ReactComponent };